/* Faveury — hafif tema etkileşimleri (Liquid bağımsız) */
(function () {
  'use strict';

  /* ---- Mobil menü ---- */
  function initBurger() {
    var burger = document.querySelector('[data-burger]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!burger || !nav) return;
    burger.addEventListener('click', function () {
      var open = nav.hasAttribute('hidden');
      if (open) { nav.removeAttribute('hidden'); } else { nav.setAttribute('hidden', ''); }
      burger.setAttribute('aria-expanded', String(open));
    });
  }

  /* ---- Ürün galerisi (PDP) ---- */
  function initGallery() {
    var thumbs = document.querySelectorAll('[data-thumb]');
    var main = document.querySelector('[data-gallery-main]');
    if (!thumbs.length || !main) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var src = t.getAttribute('data-src');
        if (src) { main.innerHTML = '<img src="' + src + '" alt="">'; }
      });
    });
  }

  /* ---- Adet sayacı ---- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelector('[data-qty-dec]').addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      wrap.querySelector('[data-qty-inc]').addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });
  }

  /* ---- Varyant / beden pill seçimi ---- */
  function initPills() {
    document.querySelectorAll('[data-pill-group]').forEach(function (group) {
      group.querySelectorAll('[data-pill]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          group.querySelectorAll('[data-pill]').forEach(function (p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          maybeSwapVariantImage(pill);
          syncStickyPrice();
        });
      });
    });
  }

  /* ---- Varyant görseli ana galeriye gelsin ---- */
  function maybeSwapVariantImage(el) {
    var src = el.getAttribute('data-variant-image');
    var main = document.querySelector('[data-gallery-main]');
    if (!src || !main) return;
    main.innerHTML = '<img src="' + src + '" alt="">';
    // ilgili thumb'ı aktifleştir
    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-src') === src);
    });
  }

  /* ---- Akordeon ---- */
  function initAccordion() {
    document.querySelectorAll('[data-acc-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.fv-acc__item');
        var open = item.classList.contains('is-open');
        item.classList.toggle('is-open', !open);
        btn.setAttribute('aria-expanded', String(!open));
      });
    });
  }

  /* ---- Sticky add-to-cart ---- */
  function syncStickyPrice() {
    var price = document.querySelector('[data-pdp-price]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    if (price && stickyPrice) stickyPrice.textContent = price.textContent.trim();
  }
  function initSticky() {
    var sticky = document.querySelector('[data-sticky-atc]');
    var anchor = document.querySelector('[data-atc-anchor]');
    if (!sticky || !anchor) return;
    syncStickyPrice();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // CTA ekrandan çıkınca sticky göster
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---- Lightbox (görsel büyüt) ---- */
  function initLightbox() {
    var main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    var box = document.createElement('div');
    box.className = 'fv-lightbox';
    box.innerHTML = '<button class="fv-lightbox__close" aria-label="Kapat"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button><div class="fv-lightbox__body"></div>';
    document.body.appendChild(box);
    var body = box.querySelector('.fv-lightbox__body');
    function open() {
      var img = main.querySelector('img');
      body.innerHTML = img ? '<img src="' + img.src + '" alt="">' : '<div class="fv-lightbox__ph"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="8.5" cy="9.5" r="1.6"/><path d="m4 17 5-5 4 4 3-3 4 4"/></svg></div>';
      box.classList.add('is-open');
    }
    function close() { box.classList.remove('is-open'); }
    main.addEventListener('click', open);
    box.addEventListener('click', function (e) { if (e.target === box || e.target.closest('.fv-lightbox__close')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---- Yıldız seçici (yorum formu) ---- */
  function initStarPicker() {
    document.querySelectorAll('[data-starpick]').forEach(function (pick) {
      var btns = [].slice.call(pick.querySelectorAll('button'));
      var input = pick.parentNode.querySelector('input[name="rating"]');
      var current = parseInt(pick.getAttribute('data-value'), 10) || 5;
      function paint(n, hover) {
        btns.forEach(function (b, i) {
          b.classList.toggle('on', !hover && i < current);
          b.classList.toggle('hover', hover && i < n);
        });
      }
      btns.forEach(function (b, i) {
        b.addEventListener('mouseenter', function () { paint(i + 1, true); });
        b.addEventListener('mouseleave', function () { paint(current, false); });
        b.addEventListener('click', function () { current = i + 1; if (input) input.value = current; paint(current, false); });
      });
      paint(current, false);
    });
  }

  /* ---- İşlevsel yorum sistemi (önizleme — localStorage) ---- */
  function reviewKey() { return 'faveury_reviews_' + (document.body.getAttribute('data-product') || 'p'); }
  function initReviews() {
    // Veri katmanı varsa (önizleme), yorumları o yönetir — burada çık.
    if (window.FaveuryDB) return;
    var form = document.querySelector('[data-review-form]');
    var list = document.querySelector('[data-review-list]');
    if (!list) return;

    function recompute() {
      var cards = [].slice.call(list.querySelectorAll('[data-review]'));
      var n = cards.length;
      var dist = [0, 0, 0, 0, 0];
      var sum = 0;
      cards.forEach(function (c) { var r = parseInt(c.getAttribute('data-stars'), 10) || 5; dist[r - 1]++; sum += r; });
      var avg = n ? (sum / n) : 0;
      var avgEl = document.querySelector('[data-rev-avg]');
      var cntEls = document.querySelectorAll('[data-rev-count]');
      if (avgEl) avgEl.textContent = avg.toFixed(1);
      cntEls.forEach(function (e) { e.textContent = n; });
      for (var s = 5; s >= 1; s--) {
        var bar = document.querySelector('[data-dist="' + s + '"]');
        if (bar) bar.style.width = (n ? Math.round(dist[s - 1] / n * 100) : 0) + '%';
      }
    }

    function cardHtml(name, date, stars, title, text) {
      var st = '';
      for (var i = 1; i <= 5; i++) st += i <= stars ? STAR : STARO;
      return '<div class="fv-review" data-review data-stars="' + stars + '">'
        + '<div class="fv-review__top"><span class="fv-avatar">' + (name[0] || '?').toUpperCase() + '</span>'
        + '<div><div class="fv-review__name">' + esc(name) + '</div><div class="fv-review__date">' + esc(date) + '</div></div>'
        + '<span class="fv-review__verified">' + CHECK + ' Doğrulanmış alışveriş</span></div>'
        + '<span class="fv-stars" style="color:var(--color-accent);">' + st + '</span>'
        + (title ? '<div class="fv-review__title">' + esc(title) + '</div>' : '')
        + '<p>' + esc(text) + '</p>'
        + '<div class="fv-review__helpful"><span>Yardımcı oldu mu?</span><button type="button" data-helpful>' + THUMB + ' Evet (0)</button></div></div>';
    }

    // kaydedilmiş yorumları yükle
    try {
      var saved = JSON.parse(localStorage.getItem(reviewKey()) || '[]');
      saved.reverse().forEach(function (r) { list.insertAdjacentHTML('afterbegin', cardHtml(r.name, r.date, r.stars, r.title, r.text)); });
    } catch (e) {}
    bindHelpful();
    recompute();

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var name = form.querySelector('[name="name"]').value.trim() || 'Misafir';
        var stars = parseInt(form.querySelector('[name="rating"]').value, 10) || 5;
        var title = form.querySelector('[name="title"]').value.trim();
        var text = form.querySelector('[name="text"]').value.trim();
        if (!text) { toast('Lütfen yorumunu yaz'); return; }
        list.insertAdjacentHTML('afterbegin', cardHtml(name, 'şimdi', stars, title, text));
        try {
          var arr = JSON.parse(localStorage.getItem(reviewKey()) || '[]');
          arr.push({ name: name, date: 'şimdi', stars: stars, title: title, text: text });
          localStorage.setItem(reviewKey(), JSON.stringify(arr));
        } catch (e2) {}
        form.reset();
        var input = form.querySelector('[name="rating"]'); if (input) input.value = 5;
        document.querySelectorAll('[data-starpick] button').forEach(function (b, i) { b.classList.toggle('on', i < 5); });
        bindHelpful();
        recompute();
        toast('Yorumun için teşekkürler!');
      });
    }

    function bindHelpful() {
      list.querySelectorAll('[data-helpful]').forEach(function (b) {
        if (b.__bound) return; b.__bound = true;
        b.addEventListener('click', function () {
          var m = b.textContent.match(/\((\d+)\)/);
          var n = (m ? parseInt(m[1], 10) : 0) + 1;
          b.innerHTML = THUMB + ' Evet (' + n + ')';
        });
      });
    }
  }

  var STAR = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.5l2.9 5.9 6.6.9-4.8 4.6 1.1 6.5L12 17.8 6.2 20.9l1.1-6.5L2.5 9.8l6.6-.9z"/></svg>';
  var STARO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"><path d="M12 2.5l2.9 5.9 6.6.9-4.8 4.6 1.1 6.5L12 17.8 6.2 20.9l1.1-6.5L2.5 9.8l6.6-.9z"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m4 12 5 5L20 6"/></svg>';
  var THUMB = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M7 11v9H3v-9zM7 11l4-8a2 2 0 0 1 3 2l-1 6h5a2 2 0 0 1 2 2.3l-1.2 6A2 2 0 0 1 19 21H7"/></svg>';
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---- Sepete ekle toast (demo) ---- */
  function toast(msg) {
    var el = document.createElement('div');
    el.textContent = msg;
    el.style.cssText = 'position:fixed;left:50%;bottom:28px;transform:translateX(-50%) translateY(20px);background:#2A2A2A;color:#fff;padding:14px 22px;border-radius:6px;font:600 14px/-apple-system,sans-serif;z-index:200;box-shadow:0 16px 40px -12px rgba(0,0,0,.4);opacity:0;transition:all .35s cubic-bezier(.22,1,.36,1)';
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.style.opacity = '1'; el.style.transform = 'translateX(-50%) translateY(0)'; });
    setTimeout(function () { el.style.opacity = '0'; el.style.transform = 'translateX(-50%) translateY(20px)'; setTimeout(function () { el.remove(); }, 400); }, 2200);
  }
  window.faveuryToast = toast;

  function initAddToCart() {
    document.querySelectorAll('[data-add-demo]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (btn.getAttribute('data-add-demo') === 'true') {
          e.preventDefault();
          toast(btn.getAttribute('data-toast') || 'Sepete eklendi');
        }
      });
    });
  }

  /* ---- Birlikte iyi gider — Shopify öneri API'si ---- */
  function initRecommendations() {
    var sec = document.querySelector('[data-rec-url]');
    if (!sec || !window.fetch) return;
    var url = sec.getAttribute('data-rec-url');
    var grid = sec.querySelector('.fv-prodgrid');
    // Sunucu zaten ürün bastıysa (fallback) tekrar çekme
    if (grid && grid.children.length > 0) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var incoming = tmp.querySelector('.fv-prodgrid');
      if (incoming && grid) grid.innerHTML = incoming.innerHTML;
    }).catch(function () {});
  }

  /* ---- Canlı Ajax sepet (gerçek Shopify mağazası) ----
     Ürün formlarını yakalar, /cart/add.js'e gönderir,
     /cart.js'ten canlı adet okuyup başlıktaki sayacı günceller.
     (Önizlemede Shopify formu yok; bu blok yalnızca canlı temada çalışır.) */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count], .fv-cart-count').forEach(function (el) {
      if (count > 0) { el.textContent = count; el.style.display = ''; }
      else { el.style.display = 'none'; }
      el.classList.add('fv-bump');
      setTimeout(function () { el.classList.remove('fv-bump'); }, 250);
    });
  }
  function refreshCart() {
    if (!window.fetch) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { updateCartCount(c.item_count); paintFreeship(c.total_price); })
      .catch(function () {});
  }
  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return false;
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    fetch(cartUrl + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newInner = doc.querySelector('#CartDrawer .drawer__inner');
        var curInner = drawer.querySelector('#CartDrawer .drawer__inner');
        if (newInner && curInner) curInner.innerHTML = newInner.innerHTML;
        var newRoot = doc.querySelector('cart-drawer');
        if (newRoot) drawer.classList.toggle('is-empty', newRoot.classList.contains('is-empty'));
        drawer.open();
      })
      .catch(function () { drawer.open(); });
    return true;
  }
  function initAjaxCart() {
    if (!window.fetch) return;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.disabled = true; }
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (item) {
            refreshCart();
            if (!openCartDrawer()) toast((item.product_title || 'Ürün') + ' sepete eklendi');
          })
          .catch(function () { toast('Bir sorun oluştu'); })
          .then(function () { if (btn) btn.disabled = false; });
      });
    });
    refreshCart();
  }

  /* ---- Hero slider (slayt sistemi) ---- */
  function initHeroSlider() {
    var root = document.querySelector('[data-hero-slider]');
    if (!root) return;
    var track = root.querySelector('[data-hero-track]');
    var slides = [].slice.call(root.querySelectorAll('[data-hero-slide]'));
    if (slides.length < 2) return;
    var dots = [].slice.call(root.querySelectorAll('[data-hero-dot]'));
    var i = 0, timer = null;
    var autoplay = root.getAttribute('data-autoplay') !== 'false';
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;

    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      slides.forEach(function (s, x) { s.classList.toggle('is-active', x === i); });
      dots.forEach(function (d, x) { d.classList.toggle('is-active', x === i); });
    }
    function next() { go(i + 1); }
    function prev() { go(i - 1); }
    function start() { if (autoplay) { stop(); timer = setInterval(next, interval); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    var pn = root.querySelector('[data-hero-next]'); if (pn) pn.addEventListener('click', function () { next(); start(); });
    var pp = root.querySelector('[data-hero-prev]'); if (pp) pp.addEventListener('click', function () { prev(); start(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-index'), 10)); start(); }); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    // dokunmatik kaydırma
    var sx = 0;
    track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; stop(); }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); }
      start();
    });

    go(0);
    start();
  }

  /* ---- Nav dropdown (klavye + dokunmatik) ---- */
  function initNavDropdown() {
    document.querySelectorAll('[data-nav-dropdown]').forEach(function (item) {
      var top = item.querySelector('.fv-nav__top');
      if (!top) return;
      top.addEventListener('click', function (e) {
        // dokunmatik/masaüstü: ilk dokunuşta aç
        if (window.matchMedia('(hover: none)').matches) {
          if (!item.classList.contains('is-open')) { e.preventDefault(); }
        }
        document.querySelectorAll('[data-nav-dropdown]').forEach(function (o) { if (o !== item) o.classList.remove('is-open'); });
        item.classList.toggle('is-open');
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-nav-dropdown]')) {
        document.querySelectorAll('[data-nav-dropdown]').forEach(function (o) { o.classList.remove('is-open'); });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') document.querySelectorAll('[data-nav-dropdown]').forEach(function (o) { o.classList.remove('is-open'); });
    });
  }

  /* ---- Koleksiyon ızgarası: sonsuz kaydırma + ürün sayısı say-yukarı ---- */
  function animateCount(el) {
    var text = el.textContent;
    var match = text.match(/\d+/);
    if (!match || el.getAttribute('data-counted')) return;
    el.setAttribute('data-counted', 'true');
    var target = parseInt(match[0], 10);
    var prefix = text.slice(0, match.index);
    var suffix = text.slice(match.index + match[0].length);
    var start = 0;
    var dur = 600;
    var t0 = performance.now();
    function step(now) {
      var p = Math.min(1, (now - t0) / dur);
      var val = Math.round(start + (target - start) * (1 - Math.pow(1 - p, 3)));
      el.textContent = prefix + val + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function observeCounts(root) {
    var counts = root.querySelectorAll('.fv-cat__count');
    if (!('IntersectionObserver' in window)) { counts.forEach(function(c){ c.setAttribute('data-counted','true'); }); return; }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { animateCount(entry.target); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.4 });
    counts.forEach(function (c) { io.observe(c); });
  }

  function initInfiniteCollections() {
    var section = document.querySelector('[data-infinite-collections]');
    if (!section) return;
    var grid = section.querySelector('[data-infinite-grid]');
    var sentinel = section.querySelector('[data-infinite-sentinel]');
    var loading = section.querySelector('[data-infinite-loading]');
    observeCounts(grid);
    if (!sentinel || !window.fetch) return;
    var loadingMore = false;

    function loadNext() {
      var link = section.querySelector('[data-infinite-next-url]');
      if (!link || loadingMore) return;
      loadingMore = true;
      if (loading) loading.hidden = false;
      fetch(link.getAttribute('data-section-url'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-infinite-grid]');
          var newLink = doc.querySelector('[data-infinite-next-url]');
          if (newGrid) {
            [].slice.call(newGrid.children).forEach(function (card) {
              card.style.opacity = '0';
              card.style.transform = 'translateY(14px)';
              grid.appendChild(card);
              requestAnimationFrame(function () {
                card.style.transition = 'opacity .45s ease, transform .45s ease';
                card.style.opacity = '1';
                card.style.transform = 'none';
              });
            });
            observeCounts(grid);
          }
          if (newLink) { link.setAttribute('data-section-url', newLink.getAttribute('data-section-url')); }
          else { link.remove(); io.disconnect(); }
          loadingMore = false;
          if (loading) loading.hidden = true;
        })
        .catch(function () { loadingMore = false; if (loading) loading.hidden = true; });
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) loadNext(); });
    }, { rootMargin: '400px 0px' });
    io.observe(sentinel);
  }

  /* ---- Kargo son saati geri sayımı (aciliyet) ---- */
  function initCutoff() {
    var el = document.querySelector('[data-cutoff]');
    if (!el) return;
    var hour = parseInt(el.getAttribute('data-hour'), 10);
    if (isNaN(hour)) hour = 16;
    var timeEl = el.querySelector('[data-cutoff-time]');
    var textEl = el.querySelector('[data-cutoff-text]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var now = new Date();
      var target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, 0, 0);
      var sameDay = now < target;
      if (!sameDay) { target.setDate(target.getDate() + 1); }
      var diff = Math.max(0, Math.floor((target - now) / 1000));
      var h = Math.floor(diff / 3600), m = Math.floor((diff % 3600) / 60), s = diff % 60;
      if (timeEl) timeEl.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      if (textEl) textEl.textContent = sameDay ? 'Bugün sipariş ver, yarın kargoda' : 'Yarın sipariş ver, ertesi gün kargoda';
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---- Ücretsiz kargo çubuğu — canlı güncelle ---- */
  function paintFreeship(total) {
    document.querySelectorAll('[data-freeship]').forEach(function (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 75000;
      var remaining = threshold - total;
      var pct = threshold > 0 ? Math.min(100, Math.round(total * 100 / threshold)) : 100;
      var fill = bar.querySelector('[data-freeship-fill]');
      var msg = bar.querySelector('[data-freeship-msg]');
      if (fill) fill.style.width = pct + '%';
      if (remaining <= 0) {
        bar.classList.add('is-complete');
        if (msg) msg.innerHTML = TRUCK + '<span><b>Ücretsiz kargo kazandın!</b> 🎉</span>';
      } else {
        bar.classList.remove('is-complete');
        if (msg) msg.innerHTML = TRUCK + '<span>Ücretsiz kargoya <b>' + money(remaining) + '</b> kaldı</span>';
      }
    });
  }
  function money(cents) { return '₺' + (cents / 100).toLocaleString('tr-TR'); }
  var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2 7h11v9H2z"/><path d="M13 10h4l3 3v3h-7z"/><circle cx="6" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>';

  /* ---- Sosyal kanıt bildirimi — GERÇEK ürün verisinden ----
     Uydurma isim/şehir/"5 dakika önce" YOK. Her kart, ürünün gerçek
     puan / değerlendirme / favori / satış / stok verisinden türetilir,
     bu yüzden her zaman doğru ve doğrulanabilir. */
  function initSocialPopup() {
    var pop = document.querySelector('[data-sppop]');
    var dataEl = document.querySelector('[data-sppop-data]');
    if (!pop || !dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data.products || !data.products.length) return;

    var interval = data.interval || 12000;
    var textEl = pop.querySelector('[data-sppop-text]');
    var prodEl = pop.querySelector('[data-sppop-prod]');
    var mediaEl = pop.querySelector('[data-sppop-media]');
    var closeBtn = pop.querySelector('[data-sppop-close]');
    var dismissed = sessionStorage.getItem('fv_sppop_off') === '1';
    var hideTimer, cycleTimer;

    // sadece hakkında söylenecek gerçek bir veri olan ürünler
    var pool = data.products.filter(function (p) {
      return (p.ratingCount > 0) || (p.weeklySales > 0) || (p.wishlist > 0) || (p.inventory > 0 && p.inventory <= 6);
    });
    if (!pool.length) return;

    function rnd(a) { return a[Math.floor(Math.random() * a.length)]; }
    function nf(n) { return Number(n).toLocaleString('tr-TR'); }
    function factFor(p) {
      var facts = [];
      if (p.weeklySales >= 4) facts.push('Bu hafta <b>' + nf(p.weeklySales) + '</b> kez satın alındı');
      if (p.ratingCount > 0 && p.rating) facts.push('<b>' + Number(p.rating).toFixed(1) + '★</b> · ' + nf(p.ratingCount) + ' doğrulanmış değerlendirme');
      if (p.wishlist >= 5) facts.push('<b>' + nf(p.wishlist) + '</b> kişinin favori listesinde');
      if (p.inventory > 0 && p.inventory <= 6) facts.push('Stokta son <b>' + p.inventory + '</b> adet');
      return facts.length ? rnd(facts) : null;
    }

    function show() {
      var tries = 0, p, fact;
      do { p = rnd(pool); fact = factFor(p); tries++; } while (!fact && tries < 8);
      if (!fact) return;
      pop.hidden = false;
      if (mediaEl) mediaEl.innerHTML = p.image ? '<a href="' + p.url + '"><img src="' + p.image + '" alt=""></a>' : BAG;
      if (textEl) textEl.innerHTML = fact;
      if (prodEl) prodEl.innerHTML = '<a href="' + p.url + '" style="color:inherit;">' + escapeHtml(p.title) + '</a>';
      requestAnimationFrame(function () { pop.classList.add('is-visible'); });
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hide, 5500);
    }
    function hide() { pop.classList.remove('is-visible'); }
    function cycle() { if (!dismissed) show(); }

    function escapeHtml(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    var BAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M6 8h12l-1 12H7z"/><path d="M9 8a3 3 0 0 1 6 0"/></svg>';

    if (closeBtn) closeBtn.addEventListener('click', function () {
      dismissed = true; hide();
      try { sessionStorage.setItem('fv_sppop_off', '1'); } catch (e) {}
      clearInterval(cycleTimer);
    });

    if (!dismissed) {
      setTimeout(function () { show(); cycleTimer = setInterval(cycle, interval); }, 4000);
    }
  }

  /* ---- Yatay kaydırmalı raylar (kategori vitrini + ürün ızgarası mobil) — ok butonları, animasyonlu native scroll ---- */
  function initRail(selector) {
    document.querySelectorAll(selector).forEach(function (wrap) {
      var track = wrap.querySelector('[data-spotrail-track], [data-prodrail-track]');
      var prev = wrap.querySelector('[data-spotrail-prev], [data-prodrail-prev]');
      var next = wrap.querySelector('[data-spotrail-next], [data-prodrail-next]');
      if (!track || !prev || !next) return;
      function step() {
        var card = track.firstElementChild;
        var gap = parseFloat(getComputedStyle(track).gap) || 24;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      function updateArrows() {
        var epsilon = 4;
        var maxScrollLeft = track.scrollWidth - track.clientWidth;
        var atStart = track.scrollLeft <= epsilon;
        var atEnd = track.scrollLeft >= maxScrollLeft - epsilon;
        if (maxScrollLeft <= epsilon) { atStart = true; atEnd = true; }
        prev.style.visibility = atStart ? 'hidden' : 'visible';
        prev.style.opacity = atStart ? '0' : '1';
        prev.style.pointerEvents = atStart ? 'none' : 'auto';
        next.style.visibility = atEnd ? 'hidden' : 'visible';
        next.style.opacity = atEnd ? '0' : '1';
        next.style.pointerEvents = atEnd ? 'none' : 'auto';
      }
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      window.addEventListener('load', updateArrows);
      if (window.ResizeObserver) { new ResizeObserver(updateArrows).observe(track); }
      updateArrows();
    });
  }
  function initSpotrail() { initRail('[data-spotrail]'); initRail('[data-prodrail]'); }

  document.addEventListener('DOMContentLoaded', function () {
    initBurger();
    initNavDropdown();
    initHeroSlider();
    initGallery();
    initQty();
    initPills();
    initAddToCart();
    initAccordion();
    initSticky();
    initLightbox();
    initStarPicker();
    initReviews();
    initRecommendations();
    initAjaxCart();
    initCutoff();
    initSocialPopup();
    initSpotrail();
    initInfiniteCollections();
  });
})();
